import relatorioResumidoPesquisaSatisfacaoHttpService from '../_services/relatorioResumidoPesquisaSatisfacaoHttpService'
import { GET_DADOS_RELATORIO } from './mutation-types'

export default {
  gerarRelatorio: async ({ commit }, form) => {
    try {
      const [responseTotal, responseDiaCorrido, responseDestino] = await Promise.all([
        relatorioResumidoPesquisaSatisfacaoHttpService.getDadosResumidosTotal(form),
        relatorioResumidoPesquisaSatisfacaoHttpService.getDadosResumidosDiaCorrido(form),
        relatorioResumidoPesquisaSatisfacaoHttpService.getDadosResumidosDestino(form),
      ])

      // console.log(responseTotal,'responseTotal')
      // console.log(responseDiaCorrido,'responseDiaCorrido')
      // console.log(responseDestino,'responseDestino')

      const responseGeral = []

      for (let i = 0; i < responseTotal.data.length; i++) {

        responseGeral.push({
          avaliacao: responseTotal.data[i].avaliacao,
          id: responseTotal.data[i].id,
          notaTotal: responseTotal.data[i].notas,
          notaDiasCorridos: responseDiaCorrido.data[i].notas,
          notaPorOperador: responseDestino.data[i].notas,
        })

      }

      commit(GET_DADOS_RELATORIO, responseGeral)
    } catch (e) {
      console.log(e)
    }
  },
}
